import { useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import UserContext from "../context/UserContext";
import { apiURL } from "../api";
import logo from "../images/logo.svg";

export default function Header() {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const { userData, setUserData } = useContext(UserContext);

  useEffect(() => {
    const getUserData = () => {
      const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      };

      fetch(apiURL + "/admin/sign", requestOptions)
        .then((response) => response.json())
        .then((response) => {
          setUserData(response.result);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {});
    };

    if (!userData) {
      getUserData();
    }
  }, [userData, setUserData]);

  const signOut = () => {
    const requestOptions = {
      method: "GET",
      credentials: "include",
    };

    fetch(apiURL + "/admin/signout", requestOptions)
      .then(() => {
        setUserData(null);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  //  Navbar
  return (
    <nav className="navbar py-0 navbar-expand-sm bg-dark navbar-dark">
      <div className="container-fluid ">
        <NavLink to="/" className="navbar-brand me-5 d-flex align-items-center">
          <svg className="me-2" width={30} height={20}>
            <defs>
              <clipPath id="cut-off-top">
                <rect rx={3} width={30} height={20} />
              </clipPath>
              <clipPath id="cut-off-bottom">
                <rect y={-10} rx={3} width={30} height={20} />
              </clipPath>
            </defs>
            <rect
              width={30}
              height={10}
              fill="#08F"
              clipPath="url(#cut-off-top)"
            ></rect>
            <rect
              width={30}
              height={10}
              fill="#FF0"
              clipPath="url(#cut-off-bottom)"
              transform="translate(0,10)"
            ></rect>
          </svg>
          <img src={logo} alt="Logo" style={{ width: "100px" }} />
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded={isDropdownOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink to="/" className="nav-link" onClick={closeDropdown}>
                <i className="bi bi-house-fill pe-1"></i>Головна
              </NavLink>
            </li>
            <li className="nav-item dropdown">
              <NavLink
                to="/tasks"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded={isDropdownOpen}
                className="nav-link dropdown-toggle"
                onClick={() => setDropdownOpen(!isDropdownOpen)}
              >
                <i className="bi bi-patch-question-fill pe-1"></i>Задачі
              </NavLink>
              <ul
                className={`dropdown-menu dropdown-menu-dark ${
                  isDropdownOpen ? "show" : ""
                }`}
              >
                <li>
                  <NavLink
                    to="/tasks/Functions"
                    className="dropdown-item"
                    onClick={closeDropdown}
                  >
                    Функції
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/tasks/dom"
                    className="dropdown-item"
                    onClick={closeDropdown}
                  >
                    DOM
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/tasks/high-priority"
                    className="dropdown-item"
                    onClick={closeDropdown}
                  >
                    З зірочкою
                  </NavLink>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="navbar-nav ms-auto">
            {userData && (
              <li className="nav-item">
                <NavLink className="nav-link text-danger" onClick={signOut}>
                  <i className="bi bi-x-circle-fill pe-1"></i>
                  {userData?.username}
                </NavLink>
              </li>
            )}
            <li className="nav-item">
              <NavLink
                to="/contacts"
                className="nav-link"
                onClick={closeDropdown}
              >
                <i className="bi bi-envelope-fill pe-1"></i>Контакти
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
